// All 5999Cargo international hubs. Source of truth for HubsPage + Contact page.

export const HUBS = [
  {
    key: "netherlands",
    country: "Netherlands",
    country_nl: "Nederland",
    label_en: "Main European Hub",
    label_nl: "Belangrijkste Europese Hub",
    address: ["Steenhouwerstraat 88", "3194 AG Rotterdam", "Netherlands"],
    phones: ["+31 488 23 5999", "+31 630 35 2160"],
    contact: "Jhon Noventa",
    emails: ["info@5999cargo.nl", "noventa@5999cargo.com"],
    featured: true,
    flag: "🇳🇱",
  },
  {
    key: "curacao",
    country: "Curaçao",
    country_nl: "Curaçao",
    label_en: "Caribbean Hub",
    label_nl: "Caribbean Hub",
    address: ["Rooseveltweg 21D", "Willemstad, Curaçao"],
    phones: ["+5999 670 5999", "+5999 689 5999"],
    contact: "Maria Gosie",
    emails: ["info@5999cargo.com"],
    featured: true,
    flag: "🇨🇼",
  },
  {
    key: "miami",
    country: "United States / Miami",
    country_nl: "Verenigde Staten / Miami",
    label_en: "USA Hub",
    label_nl: "USA Hub",
    address: ["2061 NW 112th Ave, Suite 139", "Miami, Florida 33172", "United States"],
    phones: ["+1 718 675 5695"],
    contact: "Nicolas Newman",
    emails: ["miami@5999cargo.com"],
    featured: true,
    flag: "🇺🇸",
  },
  {
    key: "aruba",
    country: "Aruba",
    country_nl: "Aruba",
    label_en: "Aruba Hub",
    label_nl: "Aruba Hub",
    address: ["Sabana Blanco 69 Unit 5", "Aruba"],
    phones: ["+297 641 6297"],
    contact: "Jermine Lacle",
    emails: ["jermine.lacle@5999cargo.com"],
    flag: "🇦🇼",
  },
  {
    key: "bonaire",
    country: "Bonaire",
    country_nl: "Bonaire",
    label_en: "Bonaire Hub",
    label_nl: "Bonaire Hub",
    address: ["Kaya Saramaca 1A", "Bonaire"],
    phones: ["+599 701 5999"],
    contact: "Roeven Martis",
    emails: ["roeven.martis@5999cargo.com"],
    flag: "🇧🇶",
  },
  {
    key: "sint-maarten",
    country: "Sint Maarten",
    country_nl: "Sint Maarten",
    label_en: "Sint Maarten Hub",
    label_nl: "Sint Maarten Hub",
    address: ["Hope Estate #4", "Sucker Garden", "Philipsburg, St. Maarten"],
    phones: ["+1 721 554 0704", "+1 721 542 9995"],
    contact: "Assiel Montiel",
    emails: ["info@5999cargo.com"],
    flag: "🇸🇽",
  },
  {
    key: "suriname",
    country: "Suriname",
    country_nl: "Suriname",
    label_en: "Suriname Hub",
    label_nl: "Suriname Hub",
    address: ["Magenatweg nr. 287", "Wanica, Suriname"],
    phones: ["+597 860 6427"],
    contact: "Anuradha Lachman",
    emails: ["a.lachman@5999cargo.com"],
    flag: "🇸🇷",
  },
  {
    key: "dominican-republic",
    country: "Dominican Republic",
    country_nl: "Dominicaanse Republiek",
    label_en: "Dominican Republic Hub",
    label_nl: "Dominicaanse Republiek Hub",
    address: ["Carretera Mella #58", "Plaza Mora", "Santo Domingo Este", "Dominican Republic"],
    phones: ["+1 829 981 5999", "+1 829 926 9614"],
    contact: "Wilson Frias",
    emails: ["repdom@5999cargo.com"],
    flag: "🇩🇴",
  },
  {
    key: "venezuela",
    country: "Venezuela",
    country_nl: "Venezuela",
    label_en: "Venezuela Hub",
    label_nl: "Venezuela Hub",
    address: ["Valencia / Caracas", "Venezuela"],
    phones: ["+58 424 406 8478", "+58 414 021 4795"],
    contact: "Shirley Fundador",
    emails: ["venezuela@5999cargo.com"],
    flag: "🇻🇪",
  },
  {
    key: "colombia",
    country: "Colombia",
    country_nl: "Colombia",
    label_en: "Colombia Hub",
    label_nl: "Colombia Hub",
    address: ["Cra 42h #82-88 LC 101", "Nuevo Horizonte", "Barranquilla, Colombia"],
    phones: ["+57 318 235 8539"],
    contact: "Wilman Salcedo",
    emails: ["wilman.salcedo@5999cargo.com"],
    flag: "🇨🇴",
  },
  {
    key: "jamaica",
    country: "Jamaica",
    country_nl: "Jamaica",
    label_en: "Jamaica Hub",
    label_nl: "Jamaica Hub",
    address: ["20 Roosevelt Avenue", "aka Arthur Wint Drive", "Kingston 6, St. Andrew", "Jamaica"],
    phones: ["+1 876 381 5238"],
    contact: "Shoshuannah Kerr-Rodney",
    emails: ["shosh.kerr@5999cargo.com"],
    flag: "🇯🇲",
  },
  {
    key: "guyana",
    country: "Guyana",
    country_nl: "Guyana",
    label_en: "Guyana Hub",
    label_nl: "Guyana Hub",
    address: ["46 Russel and Evan's Street", "Georgetown", "Guyana"],
    phones: ["+592 640 5999"],
    contact: "Jonathan Reuel Lampley",
    emails: ["jonatan.reuel@5999cargo.com"],
    flag: "🇬🇾",
  },
];

export const FEATURED_HUBS = HUBS.filter((h) => h.featured);
export const OTHER_HUBS = HUBS.filter((h) => !h.featured);
